import { ParentBusiness } from "fccore2";
import { CommonService } from 'fccore2'; 

export class FceditBusiness extends ParentBusiness { 
    /**
      * åå§åæ ¡éªè§å
      * @param mainFields ææå­æ®µ
      */
    static initValid(mainFields: any[]): any {
        let mainValid: any = {};
        mainFields.forEach(field => {
            let _validate: any = {};
            _validate.show = 'N';
            _validate.showValidator = "";
            _validate.validators = {
                "required": field.ISNULL == 'Y',//Yçæ¶åå¿å¡«
                "maxLength": field.LENGTH,
                "customVal": false
            };
            _validate.errorMessages = {
                "required": field.FIELDNAME + "ä¸è½ä¸ºç©º.",
                "maxLength": "æå¤§è¾å¥å­æ°ä¸è½è¶è¿" + field.LENGTH + "å­.",
                "customVal": "èªå®ä¹éªè¯",
            };
            _validate.fieldCode = field.FIELDCODE;
            mainValid[field.FIELDCODE] = _validate;
        });
        return mainValid;
    }

    /**
    * å¯¹æ¥æå¤çï¼ææ¶é´æ³ä¿®æ¹ä¸ºæ¥ææ ¼å¼
    */
    static initValue(mainObj: any, mainFields: any[]): void {
        Object.keys(mainObj).forEach(fieldCode => {
            let fields = mainFields.filter(field => field.FIELDCODE === fieldCode);
            if (fields.length > 0) {
                let field = fields[0];
                switch (field.DBTYPE) {
                    case "DATE":
                        mainObj[field.FIELDCODE] = CommonService.stringToDate(mainObj[field.FIELDCODE]);
                        break;
                }
            }
        })
    }

    /**
    * å¯¹æ¥æå¤çï¼ææ¥ææ¶é´æ ¼å¼ä¿®æ¹ä¸ºæ¶é´æ³
    */
    static processValue(mainObj: any, mainFields: any[]): any {
        let mainObj1 = Object.assign({}, mainObj);
        Object.keys(mainObj).forEach(fieldCode => {
            let fields = mainFields.filter(field => field.FIELDCODE === fieldCode);
            if (fields.length > 0) {
                let field = fields[0];
                switch (field.DBTYPE) {
                    case "DATE":
                        mainObj1[field.FIELDCODE] = CommonService.dateFormat(mainObj[field.FIELDCODE], "yyyy-MM-dd hh:mm:ss");
                        break;
                }
            }
        })
        return mainObj1;
    }
    /**
    * éªè¯
    */
    static validator(mainObj: any, mainValid: any, checkKey?: string): boolean {
        let flag: boolean = true;
        Object.keys(mainValid).forEach(key => {
            if ((checkKey && checkKey === key)||checkKey === null || checkKey === undefined) {
                let validator = mainValid[key];
                validator.show = 'N';
                /**å½åä¸»å¯¹è±¡çå­æ®µå¼*/
                let value = mainObj[validator.fieldCode] || '';
                /** å½åä¸»å¯¹è±¡çæ ¡éªè§å*/
                let valid = validator.validators;
                /** å½åä¸»å¯¹è±¡æ ¡éªè§åéè¯¯è¯´æ*/
                let message = validator.errorMessages;
                /** å¤æ­æ¯å¦å¿å¡«*/
                if (valid.required && (undefined === value || null == value || value.length === 0)) {
                    validator.show = 'Y';
                    validator.showValidator = "required";
                    flag = false;
                } else if (value && value.length > valid.maxLength) {
                    validator.show = 'Y';
                    validator.showValidator = "maxLength";
                    flag = false;
                } else if (valid.customVal) {
                    validator.show = 'Y';
                    validator.showValidator = "customVal";
                    flag = false;
                }
                mainValid[key] = validator;
            }
        });
        return flag;
    }
    /**
     * ä¿å­æ°å»º
     * @param mainApp å½ååæ°æ®
     * @param mainObj å½åå¯¹è±¡
     * @param mainValid æ ¡éªè§å
     * @param mainFields å½ååæ°æ®å­æ®µ
     * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
     * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
     */
    static saveNew(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: Function, afterSave: Function, pthis: any): void {
        if (!this.validator(mainObj, mainValid)) {
            return;
        }
        if (beforeSave()) {
            pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
                this.processValue(mainObj, mainFields)).subscribe(result => {
                    if (result.CODE === '0') {
                        ParentBusiness.msgService.message('ä¿å­æåï¼');
                        afterSave();
                        mainObj = ParentBusiness.appService.initObjDefaultValue(mainApp);
                    } else {
                        ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                    }
                }));
        }
    }
    /**
     * ä¿å­å¤å¶
     * @param mainApp å½ååæ°æ®
     * @param mainObj å½åå¯¹è±¡
     * @param mainValid æ ¡éªè§å
     * @param mainFields å½ååæ°æ®å­æ®µ
     * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
     * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
     */
    static cardSaveCopy(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: Function, afterSave: Function, pthis: any): void {
        if (!this.validator(mainObj, mainValid)) {
            return;
        }
        if (beforeSave()) {
            pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
                this.processValue(mainObj, mainFields)).subscribe(result => {
                    if (result.CODE === '0') {
                        ParentBusiness.msgService.message('ä¿å­æåï¼');
                        afterSave();
                        mainObj.ID = "";
                    } else {
                        ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                    }
                }));
        }
    }
    /**
     * ä¿å­å¤å¶
     * @param mainApp å½ååæ°æ®
     * @param mainObj å½åå¯¹è±¡
     * @param mainValid æ ¡éªè§å
     * @param mainFields å½ååæ°æ®å­æ®µ
     * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
     * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
     */
    static cardSave(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: Function, afterSave: Function, pthis: any): void {
        if (!this.validator(mainObj, mainValid)) {
            return;
        }
        if (beforeSave()) {
            pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
                this.processValue(mainObj, mainFields)).subscribe(result => {
                    if (result.CODE === '0') {
                        ParentBusiness.msgService.message('ä¿å­æåï¼');
                        afterSave();
                    } else {
                        ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                    }
                }));
        }
    }
    /**
     * ä¿å­è¿åæ¹æ³
     * @param mainApp å½ååæ°æ®
     * @param mainObj å½åå¯¹è±¡
     * @param mainValid æ ¡éªè§å
     * @param mainFields å½ååæ°æ®å­æ®µ
     * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
     * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
     * @param cardBack è°ç¨è¿åæ¹æ³
     */
    static cardSaveBack(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: Function, afterSave: Function, cardBack: Function, pthis: any): void {
        if (!this.validator(mainObj, mainValid)) {
            return;
        }
        if (beforeSave()) {
            pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
                this.processValue(mainObj, mainFields)).subscribe(result => {
                    if (result.CODE === '0') {
                        ParentBusiness.msgService.message('ä¿å­æåï¼');
                        afterSave();
                        cardBack();
                    } else {
                        ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                    }
                }));
        }
    }
    /**
     * ä¿®æ¹ä¸ºæä¸ªæ¨¡åå±æ§çå¼
     * @param mainObj å¯¹è±¡
     * @param fieldCode å±æ§åç§°
     * @param value å±æ§å¼
     */
    static setFieldValue(mainObj: any, fieldCode: string, value: any): any {
        mainObj[fieldCode] = value;
    }
}